/**
 * @license
 * Copyright ACCEO Solution Inc. All Rights Reserved.
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the bootstrap package.
 */

export * from './bootstrap.module';
export * from './bootstrapresolution.service';
